export const RANK_BEFORE_ID = 'rankBefore';
export const RANK_AFTER_ID = 'rankAfter';

// fake fieldIds to fetch dev summary and parent fields
export const DEV_SUMMARY_FIELD = 'devSummaryField';
export const PARENT_FIELD = 'parentField';
